const RazrjesenjeEs = () => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h2>Kio estu motivo kaj kio estu rezulto?</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <p>
                        Kio estas signoj de nia luktado kun la mondo kiuj ni povas solvi rigardante nian tutan familian
                        sistemon:
                    </p>
                    <ul>
                        <li>ripetitaj spertoj kaj malsukcesoj</li>
                        <li>problemoj en familiaj rilatoj</li>
                        <li>problemoj en rilatoj kun aliaj homoj, ripeto de sensencaj konfliktoj</li>
                        <li>daŭra kolero, malĝojo kaj malkontento</li>
                        <li>malsanoj, daŭraj kaj simptomaj</li>
                        <li>depresio, toksomanioj kaj detruaj kondutoj</li>
                        <li>nesufiĉa kaj dubinda komerca sukceso</li>
                        <li>iu ajn vivsituacio en kiu senteblas senpoveco</li>
                        <li>sento de la bezono vivi alimaniere.</li>
                    </ul>
                    <p>Dum la familiaj konstelacioj, oni faras poziciigadon en jenaj paŝoj:</p>
                    <ul>
                        <li>difino de la temo aŭ bezono</li>
                        <li>elekto de personoj aŭ objektoj aŭ nocioj kiuj bezonas esti reprezentita</li>
                        <li>komenca poziciigado de ĉiuj reprezentantoj</li>
                        <li>movado, vortaj ritoj kaj iom post iom senŝarĝiĝo de la familia sistemo</li>
                    </ul>
                    <p>
                        Rezulte, vi ekkomprenos kial io okazis ĝis nun kaj kiel preni saĝon kaj forton de la pasinteco
                        de via familio por atingi celojn en la estonteco.
                    </p>
                </div>
            </div>
        </>
    );
};

export default RazrjesenjeEs;
